import axios from "axios";

axios.defaults.withCredentials = true;

// Create axios instance
const apiClient = axios.create({
  baseURL: 'https://blockfirst.altairfin.com',
  headers: {
    "Content-type": "application/json",
    withCredentials: true
  }
});

// Add request interceptor to include fresh token with each request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth-token') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle authentication errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 302) {
      // Clear tokens and redirect to login
      localStorage.removeItem('auth-token');
      localStorage.removeItem('token');
      
      // Dispatch custom event for authentication failure
      const notification = {
        message: 'Session expired. Please login again.',
        type: 'error'
      };
      localStorage.setItem('notification', JSON.stringify(notification));
      
      const event = new Event('newMessage');
      window.dispatchEvent(event);
    }
    return Promise.reject(error);
  }
);

export default apiClient;